import { Utils } from '@genial/utils';
import React, { SVGTextElementAttributes } from 'react';

export namespace AverageTicketChartYTickTypes {
  export interface Props extends SVGTextElementAttributes<any> {
    payload?: any;
  }
}

export const AverageTicketChartYTick: React.FC<AverageTicketChartYTickTypes.Props> = ({
  payload,
  ...props
}) => <text {...props}>{Utils.Mask.ScaleMoney(payload.value)}</text>;
